import React from "react";
import {User} from "../types/Types";
import PageTracking from "../auth/PageTracking";
import {Navigate, useNavigate, useParams} from "react-router";
import {Card, Button} from "react-bootstrap";
import SuperAdminStats from "./components/SuperAdminStats";
import SuperAdminUsers from "./components/SuperAdminUsers";
import SuperAdminPubs from "./components/SuperAdminPubs";
import SuperAdminPointsConfig from "./components/SuperAdminPointsConfig";

interface Props {
    currentUser: User | undefined;
}

function AdminHome(props: Props) {
    const navigate = useNavigate();
    const { tab } = useParams<{ tab: string }>();

    // Only allow access to specific user
    if (!props.currentUser || props.currentUser.id !== "XF6i86GWnUh6pFR8GvKr93bFsOu2") {
        return <Navigate to="/home" replace />;
    }

    // Default to stats tab if no tab specified
    if (!tab) {
        return <Navigate to="/admin-home/stats" replace />;
    }

    const handleRefresh = () => {
        navigate(0);
    };

    return (
        <>
            <PageTracking />
            
            <Card className={"mb-3"}>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <div><b>Super Admin Dashboard</b></div>
                        <Button variant="primary" size="sm" onClick={handleRefresh}>
                            Refresh
                        </Button>
                    </div>
                </Card.Header>
            </Card>
            
            {tab === 'stats' && <SuperAdminStats />}
            {tab === 'users' && <SuperAdminUsers />}
            {tab === 'pubs' && <SuperAdminPubs />}
            {tab === 'points-config' && <SuperAdminPointsConfig />}
        </>
    );
}

export default AdminHome;